<template>
  <div>
   <div class="col-md-6 appinfopage">
      <h4 class="h4-title">Create Token</h4>

        <div class="form-group ">
          <label for="formGroupExampleInput">Ref ID</label>
          <input
            type="text"
            class="form-control"
            id="refid"
            placeholder="Required : string"
            v-model="form.refId"
            required
          >
        </div>
        <div class="form-group ">
          <label for="formGroupExampleInput">Token</label>
          <input
            type="text"
            class="form-control"
            id="token"
            placeholder="Required"
            v-model="form.token"
            required
          >
        </div>
        <div class="form-group ">
          <label for="formGroupExampleInput">Device Id</label>
          <input
            type="text"
            class="form-control"
            id="token"
            placeholder="Required"
            v-model="form.deviceId"
            required
          >
        </div>
        <div class="form-group ">
          <label>Platform</label>
          <b-form-select v-model="form.platform">
            <option value="all">All</option>
            <option value="ios">iOS</option>
            <option value="android">Android</option>
          </b-form-select>
        </div>
        <div class="form-group ">
          <label for="formGroupExampleInput">Tags</label>
          <vue-tags-input
                  class="tags"
                  v-model="form.tags"
                  :tags="tags"
                  placeholder="Enter Tag"
                  @tags-changed="newTags => tags = newTags"
                />
        </div>
        <hr />
        <div>
          <div class="form-group row">
            <div class="col-sm-10">
                <button
                type="button"
                class="btn btn-outline-primary"
                @click="goBack"
              >Back</button>
              <button
                type="button"
                class="btn btn-primary" style="margin-left:2px;"
                @click="createToken"
              >Create Token</button>
            </div>
          </div>
          <div class="form-group row">
            <div class="col-lg-12">
              <b-alert class="text-center" :show="successMessage != ''" variant="success"> {{ successMessage }} </b-alert>
              <b-alert class="text-center" :show="errorMessage != ''" variant="danger"> {{ errorMessage }} </b-alert>
            </div>
          </div>
        </div>

    </div>
  </div>
</template>
<script>
import VueTagsInput from '@johmun/vue-tags-input';
export default {
  data () {
    return {
      form: {},
      tags: [],
      id: '',
      errorMessage: '',
      successMessage: '',
      appName: '',
      fieldErrors: {}
    };
  },
  watch: {
  },
  methods: {
    goBack () {
      this.$router.go(-1);
    },
    createToken () {
      let refId = this.form.refId;
      let deviceId = this.form.deviceId;
      let token = this.form.token;
      let platform = this.form.platform;

      let jsonToPost = {
        'refId': refId,
        'device': {
          'id': deviceId,
          'token': token,
          'platform': platform
        },
        'tags': this.tags
      };

      this.axios.post(process.env.VUE_APP_URL_MESSAGING_API + '/device-token/register', jsonToPost)
        .then(res => {
          const respData = res.data;
          if ('Success' === respData.message) {
            this.successMessage = 'Token generated successfully';
          }
        })
        .catch(error => {
          console.log('Error :', error.response);
          this.errorMessage = error.response.data.message;
          if ('UAT-003' === error.response.data.code) {
            this.$router.push({ name: 'login' });
          }
        });
    }
  },
  components: {
    VueTagsInput
  }
};
</script>
